import createIcon from '../../createIcon';

/**
 * @component @name GridView
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgM1YxMUgxMVYzSDNaTTkgOUg1VjVIOVY5Wk0zIDEzVjIxSDExVjEzSDNaTTkgMTlINVYxNUg5VjE5Wk0xMyAzVjExSDIxVjNIMTNaTTE5IDlIMTVWNUgxOVY5Wk0xMyAxM1YyMUgyMVYxM0gxM1pNMTkgMTlIMTVWMTVIMTlWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GridView = createIcon('GridView', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 3V11H11V3H3ZM9 9H5V5H9V9ZM3 13V21H11V13H3ZM9 19H5V15H9V19ZM13 3V11H21V3H13ZM19 9H15V5H19V9ZM13 13V21H21V13H13ZM19 19H15V15H19V19Z',
      key: 'ciuarh',
    },
  ],
]);

export default GridView;
